import { render, staticRenderFns } from "./GameResultDetailsModal.vue?vue&type=template&id=bcec91aa&"
import script from "./GameResultDetailsModal.vue?vue&type=script&lang=js&"
export * from "./GameResultDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports